import React from "react";
import Chart from "../../Chart";
import ExampleLineChart from "../../../../components/Chart/ExampleLineChart";
// v9 consolidated `lineElementClasses` and `markElementClasses` into a single
// `lineClasses` object: `.root` → `.line` / `.mark`, `.highlighted` → `.highlight`.
import {lineClasses} from '@mui/x-charts-pro/LineChart';

class LineChartExampleApplet extends Chart {

    render() {
        return <ExampleLineChart applet={this}
                          attributes={this.state.Attributes}
                          xAxis={this.state.xAxis}
                          yAxis={this.state.yAxis}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "LineChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            // AxisHighlight: // { x?: 'band' | 'line' | 'none', y?: 'band' | 'line' | 'none' } default { x: 'line' }
            // BrushConfig: // { enabled?: bool, preventHighlight?: bool, preventTooltip?: bool } default undefined
            // Colors: // Array<string> | func default rainbowSurgePalette
            // Dataset: // Array<object> default undefined
            // DisableAxisListener: boolean default false
            // DisableLineItemHighlight: boolean default undefined
            // ExperimentalFeatures: { preferStrictDomainInLineCharts?: bool } default undefined
            // Grid: { horizontal?: bool, vertical?: bool } default undefined
            Height: 300, // number default undefined
            // HiddenItems: Array<{ dataIndex?: number, seriesId?: number string, type: 'line' }> default undefined
            // HideLegend: bool default undefined
            // HighlightedAxis: Array<{ axisId: number | string, dataIndex: number }> default undefined
            // HighlightedItem: { dataIndex?: number, seriesId: number | string } default undefined
            // Id: string default undefined
            // InitialZoom: Array<{ axisId: number | string, end: number, start: number }> default undefined
            // Loading: bool default false
            // LocaleText: object default undefined
            Margin: {right: 24},// number | { bottom?: number, left?: number, right?: number, top?: number } default undefined
            // onAreaClick: func default undefined
            // onAxisClick: func default undefined
            // onHiddenItemsChange: func default undefined
            // onHighlightChange: func default undefined
            // onHighlightedAxisChange: func default undefined
            // onLineClick: func default undefined
            // onMarkClick: func default undefined
            // onZoomChange: func default undefined
            // ShowToolbar: bool default false
            // SkipAnimation: bool default false
            // SlotProps: object default undefined
            // Slots: object default {}
            // Width: number default undefined
            // ZoomData: Array<{ axisId: number | string, end: number, start: number }> default undefined
            // ZoomInteractionConfig: { pan?: Array<'drag' | 'pressAndDrag' | 'wheel' | { pointerMode?: 'mouse' | 'touch', requiredKeys?: Array<string>, type: 'drag' } | { pointerMode?: 'mouse' | 'touch', requiredKeys?: Array<string>, type: 'pressAndDrag' } | { allowedDirection?: 'x'
            //                          | 'xy' | 'y', pointerMode?: any, requiredKeys?: Array<string>, type: 'wheel' }>, zoom?: Array<'brush' | 'doubleTapReset' | 'pinch'
            //                          | 'tapAndDrag' | 'wheel' | { pointerMode?: any, requiredKeys?: Array<string>, type: 'wheel' } | { pointerMode?: any, requiredKeys?: array, type: 'pinch' } | { pointerMode?: 'mouse'
            //                          | 'touch', requiredKeys?: Array<string>, type: 'tapAndDrag' }  | { pointerMode?: 'mouse' | 'touch', requiredKeys?: Array<string>, type: 'doubleTapReset' } | { pointerMode?: any, requiredKeys?: array, type: 'brush' }> }
        },
        /*
        Array<
        {
            axis?: 'x',
            barGapRatio?: number,
            categoryGapRatio?: number,
            classes?: object,
            colorMap?:
                {
                    colors: Array<string>,
                    type: 'ordinal',
                    unknownColor?: string,
                    values?: Array<Date | number | string>
                } |
                {
                    color: Array<string> | func,
                    max?: Date | number,
                    min?: Date | number,
                    type: 'continuous'
                } |
                {
                    colors: Array<string>,
                    thresholds: Array<Date | number>,
                    type: 'piecewise'
                },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            groups?: Array<{ getValue: func, tickLabelStyle?: object, tickSize?: number }>,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            offset?: number,
            ordinalTimeTicks?: Array<'biweekly' | 'days' | 'hours' | 'months' | 'quarterly' | 'weeks' | 'years' | { format: func, getTickNumber: func, isTick: func }>,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'band',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                colors: Array<string>,
                type: 'ordinal',
                unknownColor?: string,
                values?: Array<Date | number | string>
            } | {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>,
                type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            groups?: Array<{
                getValue: func,
                tickLabelStyle?: object,
                tickSize?: number
            }>,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            offset?: number,
            ordinalTimeTicks?: Array<'biweekly' | 'days' | 'hours' | 'months' | 'quarterly' | 'weeks' | 'years' | { format: func, getTickNumber: func, isTick: func }>,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'point',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>, type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number,
            min?: number,
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'log',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>, type: 'piecewise'
            },
            constant?: number,
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number,
            min?: number,
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'symlog',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>, type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number,
            min?: number,
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'pow',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>, type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number,
            min?: number,
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'sqrt',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>, type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number | { valueOf: func },
            min?: number | { valueOf: func },
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'time',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>,
                type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number | { valueOf: func },
            min?: number | { valueOf: func },
            offset?: number,
            position?: 'bottom' | 'none' | 'top',
            reverse?: bool,
            scaleType?: 'utc',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        } | {
            axis?: 'x',
            classes?: object,
            colorMap?: {
                color: Array<string> | func,
                max?: Date | number,
                min?: Date | number,
                type: 'continuous'
            } | {
                colors: Array<string>,
                thresholds: Array<Date | number>,
                type: 'piecewise'
            },
            data?: array,
            dataKey?: string,
            disableLine?: bool,
            disableTicks?: bool,
            domainLimit?: 'nice' | 'strict' | func,
            height?: number,
            hideTooltip?: bool,
            id?: number | string,
            ignoreTooltip?: bool,
            label?: string,
            labelStyle?: object,
            max?: number,
            min?: number,
            offset?: number,
            position?: 'bottom' | 'none' 'top',
            reverse?: bool,
            scaleType?: 'linear',
            slotProps?: object,
            slots?: object,
            sx?: Array<func | object | bool> | func | object,
            tickInterval?: 'auto' | array | func,
            tickLabelInterval?: 'auto' | func,
            tickLabelMinGap?: number,
            tickLabelPlacement?: 'middle' | 'tick',
            tickLabelStyle?: object,
            tickMaxStep?: number,
            tickMinStep?: number,
            tickNumber?: number,
            tickPlacement?: 'end' | 'extremities' | 'middle' | 'start',
            tickSize?: number,
            tickSpacing?: number,
            valueFormatter?: func
        }>
        */
        xAxis: [
            {
                scaleType: 'point',
                data: []
            }
        ],
        yAxis: [
            { width: 50 }
        ],
        zAxis: undefined,
        /* Array<
           {
                colorMap?: {
                    colors: Array<string>,
                    type: 'ordinal',
                    unknownColor?: string,
                    values?: Array<Date | number | string>
                } | {
                    color: Array<string> | func,
                    max?: Date | number,
                    min?: Date | number,
                    type: 'continuous'
                } | {
                    colors: Array<string>,
                    thresholds: Array<Date | number>,
                    type: 'piecewise'
                },
                data?: array,
                dataKey?: string,
                id?: string,
                max?: number,
                min?: number
           }>
        */
        Series: [
            {
                // type: "bar",
                // barLabel: "",                   // 'value' | ((item: BarItem, context: BarLabelContext) => string | null | undefined)
                // barLabelPlacement: "center",    // 'center' | 'outside'
                // color: "",                      // string
                // colorGetter: null,              // (data: ColorCallbackValue<TValue>) => string
                data: [],                          // ReadonlyArray<BarValueType | null> Data associated to each bar.
                // dataKey: "",                    // string The key used to retrieve data from the dataset.
                // highlightScope: "",             // HighlightScope The scope to apply when the series is highlighted.
                id: "pvId",                         // SeriesId
                label: "pv",                       // string | ((location: 'tooltip' | 'legend') => string) The label to display on the tooltip or the legend. It can be a string or a function.
                // labelMarkType: "",              // ChartsLabelMarkType Defines the mark type for the series. There is a default mark type for each series type.
                // layout: "",                     // 'horizontal' | 'vertical'
                // minBarSize: "",                 // number If provided, the value will be used as the minimum size of the bar in pixels. This is useful to avoid bars with a size of 0. The property is ignored if the series value is null or 0. It also doesn't work with stacked series.
                // stack: "",                      // string The key that identifies the stacking group. Series with the same stack property will be stacked together.
                // stackOffset: "",                // StackOffsetType Defines how stacked series handle negative values.
                // stackOrder: "",                 // StackOrderType The order in which series' of the same group are stacked together.
                // valueFormatter: "",             // SeriesValueFormatter<TValue> Formatter used to render values in tooltip or other data display.
                // xAxisId: "",                    // AxisId The id of the x-axis used to render the series.
                // yAxisId: ""                    // AxisId The id of the y-axis used to render the series.
            },
            {
                id: "uvId",
                data: [],
                label: 'uv'
            },
        ],
        // sx: // https://mui.com/system/getting-started/the-sx-prop/
        sx: {
          [`.${lineClasses.line}, .${lineClasses.mark}`]: {
            strokeWidth: 1,
          },
          [`.${lineClasses.line}[data-series="pvId"]`]: {
            strokeDasharray: '5 5',
          },
          [`.${lineClasses.line}[data-series="uvId"]`]: {
            strokeDasharray: '3 4 5 2',
          },
          [`.${lineClasses.mark}:not(.${lineClasses.highlight})`]: {
            fill: '#fff',
          },
          [`& .${lineClasses.highlight}`]: {
            stroke: 'none',
          }
        }
    }
}

export default LineChartExampleApplet;
